import { miniCartReportingUrl } from '@assets/product/base';
import computedStyle from '../../utils/computedStyle';

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {object} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
  $('.minicart').trigger('count:update', response);

  if ($('.add-to-cart-messages').length === 0) {
    $('body').append('<div class="add-to-cart-messages"></div>');
  } else {
    $('.add-to-cart-messages').empty();
  }

  const messageType = response.error ? 'alert-danger alert-dismissible fade show' : 'alert-success';
  const $close =
    '<button type="button" class="btn btn-close border-0 p-0" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>';
  $('.add-to-cart-messages').append(
    `<div class="alert ${messageType} add-to-basket-alert text-center" role="alert">
      ${response.error ? $close : ''}${response.message}
    </div>`
  );

  if (!response.error) {
    setTimeout(() => {
      $('.add-to-basket-alert').remove();
    }, 2000);
  }
}

/**
 * show toast response
 * @param {Object} res - from the call to set the public status of a list or item in a list
 */
function showResponseMsg(res) {
  $.spinner().stop();
  let status;

  if (res.success) {
    status = 'alert-success';
  } else {
    status = 'alert-danger';
  }

  if ($('.add-to-wishlist-messages').length === 0) {
    $('body').append('<div class="add-to-wishlist-messages"></div>');
  }

  $('.add-to-wishlist-messages').append('<div role="alert" class="add-to-wishlist-alert text-center ' + status + '">' + res.msg + '</div>');

  setTimeout(function () {
    $('.add-to-wishlist-messages').remove();
  }, 2000);
}

/**
 * toggles the public / private status of the item or wishlist item
 * @param {string} listID - the order model
 * @param {string} itemID - the customer model
 * @param {Object} callback - function to run if the ajax call returns with an
 *                        error so that the checkbox can be reset to it's original state
 */
function updatePublicStatus(listID, itemID, callback) {
  const url = $('#isPublicList').data('url');
  $.spinner().start();
  $.ajax({
    url: url,
    type: 'post',
    dataType: 'json',
    data: {
      listID: listID,
      itemID: itemID
    },
    success: function (data) {
      if (callback && !data.success) {
        callback();
      }
      showResponseMsg(data, null);
    },
    error: function (err) {
      if (callback) {
        callback();
      }
      showResponseMsg(err);
    }
  });
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - boolean for show or hide the spinner
 * @param {string} element - jquery selector of the element to append the spinner
 */
function renderNewPageOfItems(pageNumber, spinner, element) {
  const publicView = $('.wishlist-item-cards-data').data('public-view');
  const listUUID = $('.wishlist-item-cards-data').data('uuid');
  const url = $('.wishlist-item-cards-data').data('href');
  const scrollPosition = document.documentElement.scrollTop;
  let newPageNumber = pageNumber;

  if (spinner) {
    $(element).spinner().start();
  }

  $.ajax({
    url: url,
    method: 'get',
    data: {
      pageNumber: ++newPageNumber,
      publicView: publicView,
      id: listUUID
    }
  })
    .done(function (data) {
      if (spinner) {
        $(element).spinner().stop();
      }

      $('.wishlist-item-cards').empty();
      $('body .wishlist-item-cards').append(data);
      document.documentElement.scrollTop = scrollPosition;
    })
    .fail(function () {
      $.spinner().stop();
    });
}

export default class Wishlist {
  init() {
    this.removeFromWishlist();
    this.toggleWishlistStatus();
    this.toggleWishlistItemStatus();
    this.addToCartFromWishlist();
    this.moreWLItems();
    this.copyWishlistLink();
    this.submitWishlistSearch();
    this.moreWLSearchResults();
    this.handlerAddAllToCart();
    this.handlerClearAll();
    this.handlerScrollToLogin();
  }

  removeFromWishlist() {
    $('body').on('click', '.wishlist-list-item .remove-btn', function (e) {
      e.preventDefault();
      $('.product-wishlist-list-id').empty().append($(this).data('name'));
      $('.remove-from-wishlist').attr('data-url', $(this).data('url'));
    });

    const callback = this.refreshTooltip();
    $('body').on('click', '.remove-from-wishlist', function (e) {
      e.preventDefault();
      const url = $(this).attr('data-url');
      const elMyAccount = $('.account-wishlist-item').length;

      if (elMyAccount > 0) {
        $('.wishlist-account-card').spinner().start();
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'html',
          data: {},
          success: (html) => {
            $('.wishlist-account-card > .card').remove();
            $('.wishlist-account-card').append(html);
            $('.wishlist-account-card').spinner().stop();
            $('#copy-share-url-button').tooltip();
            return callback;
          },
          error: function () {
            const $elToAppend = $('.wishlist-account-card');
            const msg = $elToAppend.data('error-msg');
            $elToAppend.spinner().stop();
            showResponseMsg({ success: false, msg: msg });
          }
        });
      } else {
        $(this).spinner().start();
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          data: {},
          success: function (data) {
            const pageNumber = $('.wishlist-item-cards-data').data('page-number') - 1;
            renderNewPageOfItems(pageNumber, false);
            $(this).spinner().stop();
            $('#delete-wishlist-modal').modal('hide');

            if (data.listLength === 1) {
              $('.card-login-wishlist').removeClass('h-auto').addClass('h-100');
            }

            if (data.listIsEmpty) {
              $('.main-menu__link-wishlist').removeClass('filled');
              $('.wishlist-actions-container, .wishlist-title-container').remove();
              $('.wishlist-social-sharing').parent().remove();
            }
          },
          error: function () {
            $.spinner().stop();
            const msg = $('.wishlist-item-cards').data('error-msg');
            showResponseMsg({ success: false, msg: msg });
            $('#delete-wishlist-modal').modal('hide');
          }
        });
      }
    });
  }

  toggleWishlistStatus() {
    $('#isPublicList').on('click', function () {
      const listID = $('#isPublicList').data('id');
      updatePublicStatus(listID, null, null);
    });
  }

  toggleWishlistItemStatus() {
    $('body').on('change', '.wishlist-item-checkbox', function () {
      const itemID = $(this).closest('.wishlist-hide').find('.custom-control-input').data('id');
      const el = $(this).siblings('input');
      const resetCheckBox = function () {
        return el.prop('checked') ? el.prop('checked', false) : el.prop('checked', true);
      };

      updatePublicStatus(null, itemID, resetCheckBox);
    });
  }

  addToCartFromWishlist() {
    $('body').on('click', '.add-to-cart', function () {
      $('body').trigger('product:beforeAddToCart', this);

      const pid = $(this).data('pid');
      const addToCartUrl = $(this).data('url');
      const pidsQty = parseInt($(this).closest('.product-info').find('.quantity').val(), 10);
      const form = {
        pid: pid,
        quantity: pidsQty
      };

      if ($(this).data('option')) {
        form.options = JSON.stringify($(this).data('option'));
      }

      $(this).trigger('updateAddToCartFormData', form);
      if (addToCartUrl) {
        $.spinner().start();
        $.ajax({
          url: addToCartUrl,
          method: 'POST',
          data: form,
          success: function (data) {
            $.spinner().stop();
            $('body').trigger('product:afterAddToCart', data);
            handlePostCartAdd(data);
            miniCartReportingUrl(data.reportingURL, data.error);
          },
          error: function () {
            $.spinner().stop();
          }
        });
      }
    });
  }

  moreWLItems() {
    $('body').on('click', '.more-wishlist-items', function () {
      const pageNumber = $('.wishlist-item-cards-data').data('page-number');
      renderNewPageOfItems(pageNumber, true, $(this));
    });
  }

  copyWishlistLink() {
    $(document).on('click', '#copy-share-url-button', (e) => {
      const $this = $(e.currentTarget);
      navigator.clipboard.writeText($this.data('url')).then(
        () => {
          const text = $this.attr('data-msg-copied');
          $this.addClass('copied').attr('title', text).attr('data-original-title', text).tooltip('update').tooltip('show');
          this.refreshTooltip();
        },
        (err) => {
          $this.attr('title', err).attr('data-original-title', err).tooltip('update').tooltip('show');
          this.refreshTooltip();
        }
      );
    });
  }

  refreshTooltip() {
    $('#copy-share-url-button').on('hidden.bs.tooltip', (e) => {
      const $this = $(e.currentTarget);
      const text = $this.attr('data-init-title');
      $this.removeClass('copied').attr('title', $this.attr('data-init-title')).attr('data-original-title', text).tooltip('update');
    });
  }

  submitWishlistSearch() {
    $('body').on('click', '#wishlist-search button', function (e) {
      const firstName = $('#wishlist-search-first-name').val();
      const lastName = $('#wishlist-search-last-name').val();
      const email = $('#wishlist-search-email').val();

      if ((!firstName && !lastName && !email) || (firstName && !lastName && !email) || (!firstName && lastName && !email)) {
        e.preventDefault();
        $('.wishlist-error-search div').addClass('alert alert-danger');
        const errorText = $('.wishlist-error-search').data('error-msg');
        $('.wishlist-error-search div').html(errorText);
      }
    });
  }

  moreWLSearchResults() {
    $('body').on('click', '.more-wl-results', function () {
      const firstName = $(this).data('search-fname');
      const lastName = $(this).data('search-lname');
      let pageNumber = $(this).data('page-number');
      const uuids = [];
      const url = $(this).data('url');

      $('.wl-hit').each(function () {
        uuids.push($(this).find('a').data('id'));
      });

      $.spinner().start();
      $.ajax({
        url: url,
        method: 'POST',
        data: {
          firstName: firstName,
          lastName: lastName,
          uuids: JSON.stringify(uuids),
          pageNumber: ++pageNumber
        },
        success: function (data) {
          if (data.results.changedList) {
            $('.wl-hits .wl-hit').remove();
          }
          $('#result-count').html(data.results.totalString);
          data.results.hits.forEach(function (hit) {
            const divString =
              '<div class="row wl-hit">' +
              '<div class="text-left col-6">' +
              hit.firstName +
              ' ' +
              hit.lastName +
              '</div>' +
              '<div class="text-right col-6">' +
              '<a href="' +
              hit.url +
              '" title="' +
              hit.urlTitle +
              '" data-id="' +
              hit.id +
              '">' +
              hit.urlText +
              '</a>' +
              '</div>' +
              '</div>';
            $('.wl-hits').append(divString);
          });
          if (data.results.showMore) {
            $('.find-another-wl .more-wl-results').data('page-number', data.results.pageNumber);
          } else {
            $('.find-another-wl .more-wl-results').remove();
          }
          $.spinner().stop();
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });
  }

  handlerAddAllToCart() {
    $(document).on('click', '#wishlist-add-all-to-cart', function () {
      const setPids = [];
      const $item = $('.wishlist-list-item');

      if ($item.length > 1) {
        $item.each(function () {
          setPids.push({
            pid: $(this).attr('data-pid'),
            qty: $(this).find('.form-control.quantity').val()
          });
        });
      }

      const form = {
        pid: $item.length > 1 ? null : $item.first().attr('data-pid'),
        pidsObj: $item.length > 1 ? JSON.stringify(setPids) : null,
        childProducts: [],
        quantity: $item.length > 1 ? 0 : $item.first().find('.form-control.quantity').val()
      };

      $.spinner().start();
      $('body').trigger('product:beforeAddToCart', this);
      $(this).trigger('updateAddToCartFormData', form);
      $.ajax({
        url: $(this).attr('data-action'),
        method: 'POST',
        data: form,
        success(data) {
          $.spinner().stop();
          $('body').trigger('product:afterAddToCart', data);
          handlePostCartAdd(data);
          miniCartReportingUrl(data.reportingURL);
        },
        error() {
          $.spinner().stop();
        }
      });
    });
  }

  handlerClearAll() {
    $('body').on('click', '#clear-all-wishlist-modal-button', function (e) {
      e.preventDefault();
      const $this = $(this);

      $this.spinner().start();
      $.ajax({
        url: $this.attr('data-url'),
        type: 'get',
        dataType: 'json',
        data: {},
        success: function () {
          $this.spinner().stop();
          $('#clear-all-wishlist-modal').modal('hide');

          const url = $this.attr('data-redirect-url');
          setTimeout(function () {
            window.location.href = url;
          }, 300);
        },
        error: function () {
          $this.spinner().stop();
          showResponseMsg({ success: false, msg: $('.wishlist-item-cards').data('error-msg') });
          $('#clear-all-wishlist-modal').modal('hide');
        }
      });
    });
  }

  handlerScrollToLogin() {
    $('body').on('click', '.cta-scroll-anchor', (e) => {
      e.preventDefault();
      if ($(window).innerWidth() <= parseInt(computedStyle.get('--breakpoint-lg'))) {
        if ($(e.currentTarget).attr('data-target') === '#register') {
          $('.nav-link[data-target="#register"]').trigger('click');
        } else {
          $('.nav-link[data-target="#login"]').trigger('click');
        }

        const cardOffsetTop = $('.card-login-wishlist').offset().top;
        const headerHeight = parseInt(computedStyle.get('--header-height'));
        $('html, body').animate({ scrollTop: cardOffsetTop - headerHeight }, '300');
      }
    });
  }
}
